export { default } from './SimReplacement.container';
